import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Form, Container, Row, Col, Card, InputGroup, FormControl } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

const Historiales = ({ setSelectedPaciente, setActiveSection }) => {
  const [pacientes, setPacientes] = useState([]);
  const [filteredPacientes, setFilteredPacientes] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchPacientes = async () => {
      try {
        const pacientesResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/pacientes/`);
        const historialesResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/historiales/`);
        
        const historialesDnis = new Set(historialesResponse.data.map(h => h.dni_paciente));
        
        const pacientesConHistorial = pacientesResponse.data.filter(p => historialesDnis.has(p.dni_paciente));
        
        setPacientes(pacientesConHistorial);
        setFilteredPacientes(pacientesConHistorial);
      } catch (error) {
        console.error('Error al obtener pacientes o historiales:', error);
      }
    };
    fetchPacientes();
  }, []);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setFilteredPacientes(
      pacientes.filter(p => p.nombre_paciente.toLowerCase().includes(e.target.value.toLowerCase()))
    );
  };

  const handlePacienteClick = (dni_paciente) => {
    setSelectedPaciente(dni_paciente);
    setActiveSection("PacienteHistorial");
  };

  return (
    <Container>
      <h2 className="text-center my-4">Historias Clínicas</h2>
      <InputGroup className="mb-3">
        <InputGroup.Text><FaSearch /></InputGroup.Text>
        <FormControl
          type="text"
          placeholder="Buscar paciente..."
          value={search}
          onChange={handleSearch}
        />
      </InputGroup>
      <Row>
        {filteredPacientes.map((paciente) => (
          <Col key={paciente.dni_paciente} md={4} className="mb-3">
            <Card onClick={() => handlePacienteClick(paciente.dni_paciente)} style={{ cursor: 'pointer' }}>
              <Card.Body>
                <Card.Title>{paciente.nombre_paciente}</Card.Title>
                <Card.Text>DNI: {paciente.dni_paciente}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Historiales;